const KeenSlider = window.KeenSlider
const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductTechGlossary extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.initCarousel()
  }

  // Cloning + replacing follows the pattern in product-upsells-carousel.js's initCarousel().
  initCarousel () {
    // useArrows() attaches raw click listeners with no teardown, so re-running initCarousel
    // on the same buttons would stack duplicate handlers — clone them to drop the old ones.
    if (this.els.next?.element) {
      const clone = this.els.next.element.cloneNode(true)
      this.els.next.element.replaceWith(clone)
    }

    if (this.els.previous?.element) {
      const clone = this.els.previous.element.cloneNode(true)
      this.els.previous.element.replaceWith(clone)
    }

    // Clone the slides container to strip inline widths KeenSlider wrote while the container
    // was hidden (display: none), which otherwise leave slides stuck at min-width: 1px.
    const slidesEl = this.els.slides.element
    const slidesClone = slidesEl.cloneNode(true)
    slidesEl.replaceWith(slidesClone)

    slidesClone.removeAttribute('data-initialised')
    slidesClone.style.cssText = ''
    slidesClone.querySelectorAll(this.els.slide.selector).forEach((slide) => {
      slide.style.cssText = ''
    })

    return new KeenSlider(
      slidesClone,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 'auto',
              spacing: 32,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }

  refresh () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    this.carousel = this.initCarousel()
  }
}

if (!customElements.get('product-tech-glossary')) {
  customElements.define('product-tech-glossary', ProductTechGlossary)
}
